import { mainApiAxios as axios } from '@/plugins/axios'

export default {
    // POST body rather than a query string: an Arabic description containing & or #
    // could previously truncate or corrupt the request
    generateSurvey(description, numberOfQuestions, language) {
        return axios.post('ai-surveys/generate', { description, numberOfQuestions, language })
    }
}
